import { createFileRoute } from '@tanstack/react-router';
import { OperationsDashboard } from '@/components/dashboard/OperationsDashboard';

export const Route = createFileRoute('/_dashboard/dashboard/operations')({
  component: OperationsDashboard,
});
